/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Dispatch } from 'redux';
import Auth from '.';
import graphqlClient from '../../graphql/graphql-client';
import { GraphqlOperations } from '../../graphql/operations';
import Presentation from '../presentation';
import { graphqlSubscriptionClient } from './../../graphql/graphql-client';
import { AuthToken, Query } from './../../graphql/types/types.d';
import { IStore } from './../IStore';

const handleAuthenticationSuccess = (dispatch: Dispatch, token: AuthToken): void => {
  dispatch(Auth.actions.setAuthToken(token));
  if (
    token.expiry > 0 &&
    !token.need_password_update &&
    (token.terms_of_use === undefined || token.terms_of_use === null)
  ) {
    dispatch(Auth.actions.setUserLoggedIn());
    dispatch(Auth.actions.setTimeoutTimestamp(new Date()));
  } else {
    dispatch(Auth.actions.setUserLoggedOut());
  }
};

export const doSetAuthenticationToken = (token: AuthToken) => {
  return async (dispatch: Dispatch) => {
    dispatch(Auth.actions.setAuthToken(token));
    dispatch(Auth.actions.setTimeoutTimestamp(new Date()));
  };
};

export const doLoginFirst = (uid: string, password: string) => {
  return async (dispatch: Dispatch, getState: () => IStore) => {
    const previousFirstToken = Auth.select.selectFirstToken(getState());
    try {
      const result = await graphqlClient
        .query(
          GraphqlOperations.queries.login_first.queryString,
          GraphqlOperations.queries.login_first.createVars(uid, password),
          { requestPolicy: 'network-only' },
        )
        .toPromise();
      if (!result.error) {
        const data = result.data as Query;
        dispatch(Auth.actions.setFirstToken(data.login_first.token));
        dispatch(Auth.actions.setLoginError('first', undefined));

        // when requesting new sms code
        if (previousFirstToken) {
          dispatch(
            Presentation.actions.setToast('loginPage.toastMessages.newCodeHasBeenSent', {
              appearance: 'success',
              autoDismiss: true,
            }),
          );
        }
      } else {
        console.log('Login first failure: ', result.error);
        dispatch(Auth.actions.setLoginError('first', 'loginPage.errors.invalidCredentials'));
      }
    } catch (err) {
      console.log('Login first in store error: ', err);
      dispatch(Auth.actions.setLoginError('first', 'loginPage.errors.errorOccurred'));
    }
  };
};

export const doLoginSecond = (secret: string) => {
  return async (dispatch: Dispatch, getState: () => IStore) => {
    const token = Auth.select.selectFirstToken(getState()) || '';
    try {
      const result = await graphqlClient
        .query(
          GraphqlOperations.queries.login_second.queryString,
          GraphqlOperations.queries.login_second.createVars(token, secret),
          { requestPolicy: 'network-only' },
        )
        .toPromise();
      if (!result.error) {
        const data = result.data as Query;
        // fixing subscription client unauthenticated connection - reconnects after closing, because of reconnect: true parameter
        graphqlSubscriptionClient.close();

        handleAuthenticationSuccess(dispatch, data.login_second);
        dispatch(Auth.actions.setFinishedConfirmation(true));
        dispatch(Auth.actions.setLoginError('second', undefined));
      } else {
        console.log('Login second failure: ', result.error);
        dispatch(Auth.actions.setLoginError('second', 'loginPage.errors.invalidConfirmationCode'));
      }
    } catch (err) {
      console.log('Login second in store error: ', err);
      dispatch(Auth.actions.setLoginError('first', 'loginPage.errors.errorOccurred'));
    }
  };
};

export const doHandleApplicationStarted = () => {
  return async (dispatch: Dispatch) => {
    try {
      const result = await graphqlClient
        .query(GraphqlOperations.queries.token_validate.queryString, undefined, {
          requestPolicy: 'network-only',
        })
        .toPromise();
      if (!result.error) {
        const data = result.data as Query;
        handleAuthenticationSuccess(dispatch, data.token_validate);
      } else {
        dispatch(Auth.actions.setUserLoggedOut());
      }
    } catch (err) {
      dispatch(Auth.actions.setUserLoggedOut());
    }
  };
};

export const doPostponeTimeout = () => {
  return async (dispatch: Dispatch) => {
    try {
      const result = await graphqlClient
        .query(GraphqlOperations.queries.token_validate.queryString, undefined, {
          requestPolicy: 'network-only',
        })
        .toPromise();
      if (!result.error) {
        const data = result.data as Query;
        handleAuthenticationSuccess(dispatch, data.token_validate);
      } else {
        console.log('Timeout postpone failure: ', result.error);
        dispatch(Auth.actions.resetStore());
        dispatch(Auth.actions.setUserLoggedOut());
      }
    } catch (err) {
      console.log('Timeout postpone error: ', err);
      dispatch(Auth.actions.resetStore());
      dispatch(Auth.actions.setUserLoggedOut());
    }
  };
};

export const doLogout = () => {
  return async (dispatch: Dispatch) => {
    try {
      const result = await graphqlClient
        .mutation(GraphqlOperations.mutations.logout.mutationString)
        .toPromise();
      if (!result.error) {
        console.log('Succesful logout');
      } else {
        console.log('Logout failure: ', result.error);
      }
    } catch (err) {
      console.log('Logout error: ', err);
    }
    dispatch(Auth.actions.resetStore());
    dispatch(Auth.actions.setUserLoggedOut());
  };
};
